import { StairTravelView } from "./models"
import { directionFromRaw } from "./util"

export const STAIR_TRANSITION_MS = 450
export const STAIR_WALK_SPEED = 80

/** Walking stays in floor coordinates; the sink/rise is a separate body-only effect. */
export const stairTravelPose = (view: StairTravelView, elapsedMs: number) => {
    const elapsed = Math.max(0, Math.min(view.durationMs, elapsedMs))
    const departing = view.phase === "depart"
    const walkElapsed = departing ? elapsed : elapsed - view.transitionMs
    const walking = view.walkMs > 0 && (departing ? elapsed < view.walkMs : elapsed >= view.transitionMs && elapsed < view.durationMs)
    const walkProgress = view.walkMs ? Math.max(0, Math.min(1, walkElapsed / view.walkMs)) : 1
    const transition = Math.max(0, Math.min(1, (departing ? elapsed - view.walkMs : elapsed) / view.transitionMs))
    const smooth = transition * transition * (3 - 2 * transition)
    const depth = departing ? smooth : 1 - smooth
    const below = departing ? view.direction === "down" : view.direction === "up"
    const transitioning = departing ? elapsed >= view.walkMs : elapsed < view.transitionMs
    const ramp = view.ramp
    const upTile = departing ? view.direction === "up" : view.direction === "down"
    const approachEnd = ramp ? (upTile ? ramp.entry : ramp.top) : view.end
    const exitStart = ramp ? (upTile ? ramp.entry : ramp.top) : view.start
    const start = !departing ? exitStart : view.start
    const end = departing ? approachEnd : view.end
    const departureHeight = view.direction === "down" ? 8 : 16
    const entranceOffset = departing && (ramp || view.direction === "down") ? departureHeight * walkProgress
        : ramp ? 16 * (transitioning ? 1 : 1 - walkProgress) : 0
    const from = ramp ? (departing === upTile ? ramp.entry : ramp.top) : view.start
    const to = ramp ? (departing === upTile ? ramp.top : ramp.entry) : view.end
    const location = ramp && transitioning
        ? { x: from.x + (to.x - from.x) * transition,
            y: from.y + (to.y - from.y) * transition }
        : { x: start.x + (end.x - start.x) * walkProgress,
            y: start.y + (end.y - start.y) * walkProgress }
    return { location, walking: walking || !!ramp && transitioning && elapsed < view.durationMs,
        // Downstairs departure starts 8px south of the usual 16px raised entrance.
        transitioning, bodyOffset: (ramp && upTile ? -24 * depth : (below ? 1 : -1) * 64 * depth) - entranceOffset, below, entranceOffset,
        headClip: ramp && upTile && transitioning ? depth : undefined,
        direction: ramp && transitioning ? directionFromRaw(from.x, from.y, to.x, to.y) ?? view.exitDirection : view.exitDirection,
        angle: ramp && transitioning ? Math.atan2(to.y - from.y, to.x - from.x) : view.exitAngle }
}
